import UIOptimisticNanoProgress from 'UIComponents/progress/UIOptimisticNanoProgress';
import { getBranchIndex, getEdgeIdFromGoToActionId, getPreviousActionId, isGoToActionId } from 'automation-ui-action-features/records/recordsUtils';
import FlowCanvasNode from 'automation-ui-canvas/components/canvas/FlowCanvasNode';
import PannableDecorator from 'automation-ui-canvas/decorators/PannableDecorator';
import ZoomableDecorator from 'automation-ui-canvas/decorators/ZoomableDecorator';
import { getActionOutputsForTargetActionById } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { Component, createRef } from 'react';
import { NavMarker } from 'react-rhumb';
import { withRouter } from 'react-router-dom';
import getComponentName from 'react-utils/getComponentName';
import { compose } from 'redux';
import styled from 'styled-components';
import BranchName from 'automation-ui-canvas/components/canvas/BranchName';
import { wireGetEnrollmentConversionDetails } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionDetails';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import BranchLabel from 'automation-ui-canvas/components/canvas/BranchLabel';
import { BATTLESHIP, OZ_DARK } from 'HubStyleTokens/colors';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import ModeIndicator from 'automation-ui-canvas/containers/enrollment-history/utils/ModeIndicator';
import { wireGetEnrollmentConversionTrackingStatus } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionTrackingStatus';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getFlowEditRoute, parseLocation } from 'automation-ui-routing/utils';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { formatNumberForEnrollmentConversionReporting, formatPercentageForEnrollmentConversionReporting } from 'automation-ui-canvas/containers/enrollment-conversion/enrollmentConversionUtils';
import { wireFlowByVersion } from 'automation-ui-canvas/containers/enrollment-history/wireFlowByVersion';
import { queryAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import ActionCardWithNoDetails from 'automation-ui-canvas/containers/enrollment-history/ActionCardWithNoDetails';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import EnrollmentConversionMessage from 'automation-ui-canvas/containers/enrollment-conversion/EnrollmentConversionMessage';
import EndMarker from 'automation-ui-canvas/components/common/EndMarker';
import { getMetricsUrl } from 'automation-ui-canvas/utils/urls';
import partial from 'transmute/partial';
import BranchDescription from 'automation-ui-canvas/components/canvas/BranchDescription';
import { ExpandIcon, BlockIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledCanvas = styled.div.withConfig({
  displayName: "FlowCanvasEnrollmentConversionDecorator__StyledCanvas",
  componentId: "sc-1xn1bg3-0"
})(["height:100%;"]);
const StyledUIOptimisticNanoProgress = styled(UIOptimisticNanoProgress).withConfig({
  displayName: "FlowCanvasEnrollmentConversionDecorator__StyledUIOptimisticNanoProgress",
  componentId: "sc-1xn1bg3-1"
})(["position:absolute;top:0;left:0;right:0;"]);
const StyledEnrollmentHeader = styled.div.withConfig({
  displayName: "FlowCanvasEnrollmentConversionDecorator__StyledEnrollmentHeader",
  componentId: "sc-1xn1bg3-2"
})(["display:flex;justify-content:center;"]);
function getComposedCanvas() {
  return PannableDecorator(
  // @ts-expect-error ZoomableDecorator expects StyledCanvas to have its required props, but it's just a div
  // and the required props aren't wired until ComposedCanvas is used in FlowCanvasBase. Not sure if real error or not
  ZoomableDecorator({
    WrappedComponent: StyledCanvas
  }));
}
export default function FlowCanvasEnrollmentConversionDecorator(WrappedComponent, centerOnMount) {
  const componentName = getComponentName(WrappedComponent);
  class FlowCanvasEnrollmentConversion extends Component {
    constructor(...args) {
      super(...args);
      this.isNodeHighlighted = nodeId => this.state.mostVisitedPathIds.includes(nodeId);
      this.isMetBranch = edgeId => {
        const {
          flow
        } = this.props;
        const {
          mostVisitedPathIds
        } = this.state;
        const branchActionId = getPreviousActionId(edgeId);
        const action = flow.actions.get(branchActionId);
        const nextActionId = action.getNextActionIdByEdgeId(edgeId);
        return nextActionId === null && mostVisitedPathIds[mostVisitedPathIds.length - 1] === branchActionId || mostVisitedPathIds.includes(branchActionId) && mostVisitedPathIds.includes(nextActionId);
      };
      this.isEdgeHighlighted = edgeId => {
        var _flow$actions$find;
        const {
          mostVisitedPathIds
        } = this.state;
        const {
          flow
        } = this.props;
        const prevActionId = getPreviousActionId(edgeId);
        const isPrevActionBranch = (_flow$actions$find = flow.actions.find(action => action.actionId === prevActionId)) === null || _flow$actions$find === void 0 ? void 0 : _flow$actions$find.isBranch();
        return isPrevActionBranch && this.isMetBranch(edgeId) || !isPrevActionBranch && mostVisitedPathIds.includes(prevActionId);
      };
      this.handleGetActionOutputsForTargetActionById = (targetActionId, isNew) => getActionOutputsForTargetActionById({
        flow: this.props.flow,
        allOutputsByActionTypeId: this.props.allOutputsByActionTypeId,
        instanceOutputsByActionId: this.props.instanceOutputsByActionId,
        targetActionId,
        isNewAction: isNew
      });
      this.updateURLWithActiveActionId = actionId => {
        const {
          history,
          flowId
        } = this.props;
        const searchParams = new URLSearchParams(history.location.search);
        searchParams.set('activeActionId', actionId);
        history.replace({
          pathname: getMetricsUrl({
            flowId
          }),
          search: searchParams.toString()
        });
      };
      this.onSelectAction = id => {
        trackEvent(Trackables.AGGREGATE_PERFORMANCE_CLICK_ACTION_CARD);
        this.updateURLWithActiveActionId(id.toString());
      };
      this.onRenderCanvasNode = ({
        id,
        width,
        height
      }) => {
        var _conversionReport$tot, _searchParams$get$spl, _searchParams$get;
        const {
          enrollmentConversionData,
          flow,
          isMulti,
          isReportingEnabled,
          history,
          allExtensionDefinitionsQuery,
          activeActionId
        } = this.props;
        if (!flow) {
          return null;
        }
        const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
        const totalEnrollmentCount = (_conversionReport$tot = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot !== void 0 ? _conversionReport$tot : 0;
        let bannerText = null;
        let bannerStyle = undefined;
        let borderStyle = undefined;
        let clickable = true;
        if (id === SpecialActionIds.ENROLLMENT) {
          bannerText = /*#__PURE__*/_jsx(StyledEnrollmentHeader, {
            children: isReportingEnabled ? /*#__PURE__*/_jsx(UITooltip, {
              title: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation.enrollmentConversion.panel.tooltips.enrollment",
                options: {
                  value: formatNumberForEnrollmentConversionReporting(totalEnrollmentCount)
                }
              }),
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(UIIcon, {
                  name: "success",
                  size: "xxs",
                  className: "p-right-2"
                }), formatNumberForEnrollmentConversionReporting(totalEnrollmentCount)]
              })
            }) : /*#__PURE__*/_jsx(UITooltip, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.enrollmentConversion.tooltips.defaultEnrollment"
              }),
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(UIIcon, {
                  name: "success",
                  size: "xxs",
                  className: "p-right-2"
                }), /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.enrollmentConversion.defaultState.enrolled"
                })]
              })
            })
          });
          bannerStyle = 'success_no_icon';
          clickable = false;
        }
        const overrideTitleAction = () => {
          var _actionCounts$unenrol, _actionCounts$executi;
          const actionCounts = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.actionStatusCounts[id];
          const unenrolledCount = (_actionCounts$unenrol = actionCounts === null || actionCounts === void 0 ? void 0 : actionCounts.unenrolled) !== null && _actionCounts$unenrol !== void 0 ? _actionCounts$unenrol : 0;
          const unenrolledPercentage = totalEnrollmentCount !== 0 ? unenrolledCount / totalEnrollmentCount * 100 : 0;
          const executionErrorsCount = (_actionCounts$executi = actionCounts === null || actionCounts === void 0 ? void 0 : actionCounts.executionErrors) !== null && _actionCounts$executi !== void 0 ? _actionCounts$executi : 0;
          const executionErrorsPercentage = totalEnrollmentCount !== 0 ? executionErrorsCount / totalEnrollmentCount * 100 : 0;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(UITooltip, {
              title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation.enrollmentConversion.tooltips.unenrolled",
                options: {
                  value: formatPercentageForEnrollmentConversionReporting(unenrolledPercentage)
                }
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.enrollmentConversion.tooltips.defaultUnenrolled"
              }),
              children: /*#__PURE__*/_jsxs("span", {
                children: [unenrolledCount > 0 ? /*#__PURE__*/_jsx("span", {
                  className: "p-right-2",
                  children: /*#__PURE__*/_jsx(IconCircle, {
                    color: "icon-primary-on-fill-default",
                    backgroundColor: "fill-caution-pressed",
                    icon: ExpandIcon,
                    size: "300",
                    padding: "100",
                    marginInlineEnd: "100"
                  })
                }) : /*#__PURE__*/_jsx(UIIcon, {
                  name: "expand",
                  size: 16,
                  className: "p-right-2 p-left-2"
                }), isReportingEnabled ? formatNumberForEnrollmentConversionReporting(unenrolledCount) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.enrollmentConversion.defaultState.exits"
                })]
              })
            }), /*#__PURE__*/_jsx(UITooltip, {
              title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation.enrollmentConversion.tooltips.errored",
                options: {
                  value: formatPercentageForEnrollmentConversionReporting(executionErrorsPercentage)
                }
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.enrollmentConversion.tooltips.defaultErrored"
              }),
              children: /*#__PURE__*/_jsxs("span", {
                children: [executionErrorsCount > 0 ? /*#__PURE__*/_jsx("span", {
                  className: "p-right-2",
                  children: /*#__PURE__*/_jsx(IconCircle, {
                    color: "icon-primary-on-fill-default",
                    backgroundColor: "fill-alert-default",
                    icon: BlockIcon,
                    size: "300",
                    padding: "100",
                    marginInlineEnd: "100"
                  })
                }) : /*#__PURE__*/_jsx(UIIcon, {
                  name: "blocked",
                  size: 16,
                  className: "p-right-2 p-left-2"
                }), isReportingEnabled ? formatNumberForEnrollmentConversionReporting(executionErrorsCount) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.enrollmentConversion.defaultState.errors"
                })]
              })
            })]
          });
        };
        const isNodeHighlighted = this.isNodeHighlighted(id);
        borderStyle = isNodeHighlighted ? 'success' : undefined;
        if (isGoToActionId(id)) {
          const edgeId = getEdgeIdFromGoToActionId(id);
          if (this.isEdgeHighlighted(edgeId)) {
            borderStyle = 'success';
          }
        }
        const searchParams = new URLSearchParams(history.location.search);
        const changedActions = (_searchParams$get$spl = (_searchParams$get = searchParams.get('changedActions')) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.split(',')) !== null && _searchParams$get$spl !== void 0 ? _searchParams$get$spl : [];
        if (changedActions.includes(id.toString())) {
          var _allExtensionDefiniti, _allExtensionDefiniti2;
          const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};
          return /*#__PURE__*/_jsx(ActionCardWithNoDetails, {
            nodeId: id,
            clickable: clickable,
            flow: flow,
            extensionDefinitions: extensionDefinitions,
            width: width,
            height: height,
            showIcon: !isMulti,
            borderStyle: borderStyle,
            bannerText: bannerText,
            bannerStyle: bannerStyle,
            TitleAction: typeof id === 'number' ? overrideTitleAction : undefined,
            onClick: this.onSelectAction && partial(this.onSelectAction, id),
            isSelected: activeActionId === id
          });
        }
        return /*#__PURE__*/_jsx(FlowCanvasNode, {
          id: id,
          width: width,
          clickable: clickable,
          height: height,
          flow: flow,
          readOnly: true,
          showIcon: !isMulti,
          getActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById,
          overrideTitleAction: typeof id === 'number' ? overrideTitleAction : undefined,
          overrideAccentColor: BATTLESHIP,
          bannerText: bannerText,
          bannerStyle: bannerStyle,
          isHighlighted: isNodeHighlighted,
          borderStyle: borderStyle,
          onSelectNode: this.onSelectAction,
          isSelected: activeActionId === id
        });
      };
      this.onRenderBranchName = edgeId => {
        var _conversionReport$sou, _actionBranchPrevActi3, _actionBranchPrevActi4;
        const {
          enrollmentConversionData,
          flow,
          isReportingEnabled
        } = this.props;
        const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
        const prevActionId = getPreviousActionId(edgeId);
        let label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.defaultState.continued"
        });
        const action = flow.actions.get(prevActionId);
        const nextActionId = action.getNextActionIdByEdgeId(edgeId);
        const actionBranchPrevActionIdObj = conversionReport === null || conversionReport === void 0 || (_conversionReport$sou = conversionReport.sourceDestinationMap) === null || _conversionReport$sou === void 0 ? void 0 : _conversionReport$sou[prevActionId];
        const branchTotal = actionBranchPrevActionIdObj ? Object.values(actionBranchPrevActionIdObj).reduce((prev, next) => prev + next, 0) : 0;
        if (isReportingEnabled) {
          if (nextActionId) {
            var _actionBranchPrevActi;
            const actionBranchCount = (_actionBranchPrevActi = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[nextActionId]) !== null && _actionBranchPrevActi !== void 0 ? _actionBranchPrevActi : 0;
            const percentage = branchTotal !== 0 ? actionBranchCount / branchTotal * 100 : 0;
            label = formatPercentageForEnrollmentConversionReporting(percentage);
          } else {
            var _actionBranchPrevActi2;
            const actionBranchCount = (_actionBranchPrevActi2 = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[`end-${getBranchIndex(edgeId)}`]) !== null && _actionBranchPrevActi2 !== void 0 ? _actionBranchPrevActi2 : 0;
            const percentage = branchTotal !== 0 ? actionBranchCount / branchTotal * 100 : 0;
            label = formatPercentageForEnrollmentConversionReporting(percentage);
          }
        }
        return /*#__PURE__*/_jsx(BranchLabel, {
          branchLabelHeaderText: /*#__PURE__*/_jsx(BranchName, {
            flow: flow,
            edgeId: edgeId,
            handleGetActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById
          }),
          branchDescription: /*#__PURE__*/_jsx(BranchDescription, {
            flow: flow,
            edgeId: edgeId
          }),
          hideFooter: false,
          branchLabelFooterText: label,
          footerTooltipTitle: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation.enrollmentConversion.tooltips.branch",
            options: {
              value: nextActionId ? formatNumberForEnrollmentConversionReporting((_actionBranchPrevActi3 = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[nextActionId]) !== null && _actionBranchPrevActi3 !== void 0 ? _actionBranchPrevActi3 : 0) : (_actionBranchPrevActi4 = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[`end-${getBranchIndex(edgeId)}`]) !== null && _actionBranchPrevActi4 !== void 0 ? _actionBranchPrevActi4 : 0,
              total: formatNumberForEnrollmentConversionReporting(branchTotal !== null && branchTotal !== void 0 ? branchTotal : 0)
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.tooltips.defaultBranch"
          }),
          borderStyle: this.isMetBranch(edgeId) ? 'success' : undefined
        });
      };
      this.onRenderEndMarker = ({
        edgeId
      }) => {
        var _conversionReport$tot2, _endActionCounts$work2;
        const {
          enrollmentConversionData,
          isReportingEnabled,
          flow
        } = this.props;
        const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
        const totalEnrollmentCount = (_conversionReport$tot2 = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot2 !== void 0 ? _conversionReport$tot2 : 0;
        const endActionId = getPreviousActionId(edgeId);
        const endActionCounts = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.actionStatusCounts[endActionId];
        let label = '';
        if (isReportingEnabled) {
          var _endActionCounts$work;
          const actionBranchCount = (_endActionCounts$work = endActionCounts === null || endActionCounts === void 0 ? void 0 : endActionCounts.workflowCompleted) !== null && _endActionCounts$work !== void 0 ? _endActionCounts$work : 0;
          const percentage = totalEnrollmentCount !== 0 ? actionBranchCount / totalEnrollmentCount * 100 : 0;
          label = formatPercentageForEnrollmentConversionReporting(percentage);
        } else {
          label = /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.defaultState.ended"
          });
        }
        return /*#__PURE__*/_jsx(EndMarker, {
          hideFooter: false,
          borderStyle: this.isEdgeHighlighted(edgeId) ? 'success' : undefined,
          flow: flow,
          edgeId: edgeId,
          endMarkerFooterText: label,
          footerTooltipTitle: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation.enrollmentConversion.tooltips.end",
            options: {
              value: formatNumberForEnrollmentConversionReporting((_endActionCounts$work2 = endActionCounts === null || endActionCounts === void 0 ? void 0 : endActionCounts.workflowCompleted) !== null && _endActionCounts$work2 !== void 0 ? _endActionCounts$work2 : 0),
              total: formatNumberForEnrollmentConversionReporting(totalEnrollmentCount)
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.tooltips.defaultEnd"
          })
        });
      };
      this.renderTopContent = () => {
        const {
          isReportingEnabled,
          reportingStatusLastUpdated,
          enrollmentConversionData
        } = this.props;
        if (!reportingStatusLastUpdated || !isReportingEnabled) {
          return null;
        }
        return /*#__PURE__*/_jsx(EnrollmentConversionMessage, {
          reportingStatusLastUpdated: reportingStatusLastUpdated,
          enrollmentConversionData: enrollmentConversionData
        });
      };
      this.getComposedProps = () => {
        const {
          flow,
          canvasScrollElementRef
        } = this.props;
        return {
          flow,
          canvasScrollElementRef,
          ComposedCanvas: this.ComposedCanvas,
          readOnlyOverride: true,
          // Used for permission overrides like revisions and enrollment history
          centerOnMount,
          highlightedActionIds: new Set(this.state.mostVisitedPathIds),
          onRenderCanvasNode: this.onRenderCanvasNode,
          onRenderBranchName: this.onRenderBranchName,
          onRenderEndMarker: this.onRenderEndMarker,
          onSelectAction: this.onSelectAction,
          TopContent: this.renderTopContent(),
          highlightedEdgeThickness: 4,
          highlightedEdgeColor: OZ_DARK,
          getIsBranchEdgeHighlighted: this.isMetBranch
        };
      };
      this.renderContent = () => {
        const {
          enrollmentConversionData,
          flow,
          reportingStatusLoading,
          allExtensionDefinitionsQuery,
          isReportingEnabled,
          versionId
        } = this.props;
        const isLoading = !flow || isReportingEnabled && !enrollmentConversionData || reportingStatusLoading || !versionId;
        if (isLoading || allExtensionDefinitionsQuery.loading) {
          return /*#__PURE__*/_jsx(StyledUIOptimisticNanoProgress, {
            value: 10
          });
        }
        return /*#__PURE__*/_jsx(NavMarker, {
          name: "ENROLLMENT_CONVERSION_CANVAS",
          children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, this.getComposedProps()))
        });
      };
      this.ComposedCanvas = getComposedCanvas();
      this.headerRef = /*#__PURE__*/createRef();
      this.state = {
        actionCardCountersMap: {},
        mostVisitedPathIds: []
      };
    }
    static getDerivedStateFromProps(props, state) {
      var _mostVisitedPathObj$c;
      const {
        enrollmentConversionData,
        flow,
        isFlowLoading
      } = props;
      if (isFlowLoading || !flow || !enrollmentConversionData) {
        return state;
      }
      let completeMostVisitedPathIds = [];
      const mostVisitedPathObj = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport.completePathCounts.reduce((prev, current) => prev && prev.count > current.count ? prev : current, {
        count: 0,
        completePath: []
      });
      const mostVisitedPathIds = (_mostVisitedPathObj$c = mostVisitedPathObj === null || mostVisitedPathObj === void 0 ? void 0 : mostVisitedPathObj.completePath) !== null && _mostVisitedPathObj$c !== void 0 ? _mostVisitedPathObj$c : [];
      completeMostVisitedPathIds = mostVisitedPathIds.length > 0 ? [SpecialActionIds.ENROLLMENT, ...mostVisitedPathIds] : [];
      return {
        mostVisitedPathIds: completeMostVisitedPathIds
      };
    }
    render() {
      const {
        flowId,
        history
      } = this.props;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ModeIndicator, {
          onCancel: () => {
            trackEvent(Trackables.AGGREGATE_PERFORMANCE_CLOSE_MODE_INDICATOR);
            history.push(getFlowEditRoute(flowId));
          },
          dataTestId: "aggregate-performance-mode-indicator",
          modeTitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.mode.title"
          })
        }), this.renderContent()]
      });
    }
  }
  const ConnectedFlowCanvasEnrollmentConversion = compose(wireAuthConsumer, withRouter, wireGetEnrollmentConversionTrackingStatus, _WrappedComponent => props => {
    const parsedQuery = parseLocation(props.location);
    const versionId = parsedQuery.version;
    const activeActionId = parsedQuery.activeActionId;
    return /*#__PURE__*/_jsx(_WrappedComponent, Object.assign({}, props, {
      flowId: Number(props.match.params.flowId),
      versionId: versionId ? Number(versionId) : undefined,
      activeActionId: activeActionId ? Number(activeActionId) : undefined
    }));
  }, wireFlowByVersion, queryAllExtensionDefinitions,
  // Requires flowSourceApp and flowObjectTypeId
  wireGetEnrollmentConversionDetails)(FlowCanvasEnrollmentConversion);
  ConnectedFlowCanvasEnrollmentConversion.displayName = `ConnectedFlowCanvasEnrollmentConversion(${componentName})`;
  attachWrappedComponent(ConnectedFlowCanvasEnrollmentConversion, WrappedComponent);
  return ConnectedFlowCanvasEnrollmentConversion;
}